import { useState, useCallback } from 'react';

interface UsePhoneNumberReturn {
  phoneNumber: string;
  handlePhoneChange: (value: string) => void;
  getCleanPhoneNumber: () => string;
}

export const usePhoneNumber = (initialValue: string = ''): UsePhoneNumberReturn => {
  const [phoneNumber, setPhoneNumber] = useState(initialValue);

  // 전화번호에 하이픈 추가하는 함수
  const formatPhoneNumber = useCallback((value: string): string => {
    // 숫자만 추출
    const numbers = value.replace(/[^0-9]/g, '');

    // 길이에 따라 하이픈 추가
    if (numbers.length <= 3) {
      return numbers;
    } else if (numbers.length <= 7) {
      return `${numbers.slice(0, 3)}-${numbers.slice(3)}`;
    } else {
      return `${numbers.slice(0, 3)}-${numbers.slice(3, 7)}-${numbers.slice(7, 11)}`;
    }
  }, []);

  // 전화번호 변경 핸들러
  const handlePhoneChange = useCallback((value: string) => {
    const formatted = formatPhoneNumber(value);
    setPhoneNumber(formatted);
  }, [formatPhoneNumber]);

  // 하이픈이 제거된 깨끗한 전화번호 반환
  const getCleanPhoneNumber = useCallback((): string => {
    return phoneNumber.replace(/[^0-9]/g, '');
  }, [phoneNumber]);

  return {
    phoneNumber,
    handlePhoneChange,
    getCleanPhoneNumber
  };
}; 